import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AGIndustries.css';

const ITEMS_GALERIA = [
  { id: 1, img: '/imagen1.jpeg', titulo: 'Colección I', categoria: 'Autos' },
  { id: 2, img: '/imagen2.jpeg', titulo: 'Colección II', categoria: 'Retratos' },
];

const AGIndustries = () => {
  const [animar, setAnimar] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [menuCerrando, setMenuCerrando] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [itemActivo, setItemActivo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  useEffect(() => {
    if (menuAbierto) {
      document.body.classList.add('menu-abierto');
    } else {
      document.body.classList.remove('menu-abierto');
    }
  }, [menuAbierto]);

  useEffect(() => {
    const thumb = document.createElement('div');
    thumb.style.cssText = `
      position: fixed;
      right: 2px;
      top: 0;
      width: 3px;
      background: rgba(139, 90, 60, 0.6);
      border-radius: 10px;
      z-index: 9999;
      pointer-events: none;
      transition: opacity 0.3s;
      opacity: 0;
    `;
    document.body.appendChild(thumb);

    let timeout;
    const updateThumb = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = scrollTop / docHeight;
      const thumbHeight = Math.max((window.innerHeight / document.documentElement.scrollHeight) * window.innerHeight, 40);
      const thumbTop = percent * (window.innerHeight - thumbHeight);

      thumb.style.height = thumbHeight + 'px';
      thumb.style.top = thumbTop + 'px';
      thumb.style.opacity = '1';

      clearTimeout(timeout);
      timeout = setTimeout(() => { thumb.style.opacity = '0'; }, 1000);
    };

    window.addEventListener('scroll', updateThumb);
    return () => {
      window.removeEventListener('scroll', updateThumb);
      document.body.removeChild(thumb);
    };
  }, []);

  const ejecutarAnimacionYLink = () => {
    setAnimar(true);
    setTimeout(() => {
      window.open('/edit', '_blank');
      setAnimar(false);
    }, 800);
  };

  return (
    <div className={`sx-wrapper ${animar ? 'efecto-salida' : ''}`}>

      {/* VIDEO DE FONDO */}
      <div className="sx-video-bg">
        <video autoPlay muted loop playsInline className="sx-video">
          <source src="/Vino1.mp4" type="video/mp4" />
        </video>
        <div className="sx-video-overlay" />
      </div>

      {/* HEADER FIJO */}
      <header className={`sx-header ${scrolled ? 'scrolled' : ''}`}>
        <button
          className={`sx-hamburger ${menuAbierto ? 'is-open' : ''} ${scrolled ? 'hamburger-oculta' : ''}`}
          onClick={() => setMenuAbierto(!menuAbierto)}
          aria-label="Menú"
        >
          <span />
          <span />
          <span />
        </button>
        <img src="/Reynadelvino.png" alt="Reina del Vino" className={`sx-header-logo ${menuAbierto ? 'logo-oculto' : ''}`} />
        <div className="sx-header-right" />
      </header>

      {/* MENÚ OVERLAY */}
      {menuAbierto && (
        <div className="sx-menu-overlay" onClick={() => setMenuAbierto(false)}>
          <nav className="sx-menu" onClick={(e) => e.stopPropagation()}>
            <ul>
              <li><a href="/" onClick={() => setMenuAbierto(false)}>Inicio</a></li>
             <li><a href="#historia" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); document.getElementById('historia')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }}>Historia</a></li>
             <li><a href="#reinados" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); document.getElementById('reinados')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }}> Reinados</a></li>
             <li><a href="#embajadoras" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); setTimeout(() => { document.getElementById('embajadoras')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }, 300); }}>Embajadoras</a></li>
             <li><a href="#registrate" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); document.getElementById('registrate')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }}>Regístrate</a></li>
             <li><a href="#ediciones" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); setTimeout(() => { document.getElementById('ediciones')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }, 300); }}>1er Edición</a></li>
             <li><a href="#sponsors" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); document.getElementById('sponsors')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }}>Sponsors</a></li>
             <li><a href="#alianzas" onClick={(e) => { e.preventDefault(); setMenuAbierto(false); document.getElementById('alianzas')?.scrollIntoView({ behavior: 'smooth' }); history.pushState(null, '', window.location.pathname); }}>Alianzas</a></li>
              <li>
                <button className="sx-menu-link" onClick={ejecutarAnimacionYLink}></button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {/* HERO */}
      <section className="sx-hero"></section>

      {/* ══ HISTORIA ══ */}
      <section id="historia" className="sx-seccion-historia">
        <div className="sx-historia-content">
          <h1>HISTORIA</h1>
        </div>
        <img src="/IMG1-HISTORIA.jpeg" alt="Historia" className="sx-historia-img" />
        <div className="sx-historia-content">
          <p>Un certamen que nació con <strong>Bodega Antonio González</strong> en Veracruz; ¿La idea? 
           Promover una nueva ruta del vino en el país, de la mano de su fundador como creador.
          </p>
        </div>
      </section>

      {/* ══ REGISTRATE ══ */}
      <section id="registrate" className="sx-seccion-registrate">
        <div className="sx-historia-content">
          <h1>REGÍSTRATE</h1>
        </div>
        <img src="/IMG1-REGISTRATE.jpeg" alt="Regístrate" className="sx-historia-img sx-registrate-img" />
        <div className="sx-historia-content">
          <p>No es para todas, vive una experiencia única y al completar el formulario podrás dar el primer paso para convertirte en candidata a Reina del Vino.</p>
          <a onClick={() => navigate('/registrate')} className="sx-descubrir" style={{ cursor: 'pointer' }}>Registrarme</a>
        </div>
      </section>

      {/* ══ EMBAJADORAS ══ */}
      <section id="embajadoras" className="sx-seccion-embajadoras">
        <div className="sx-historia-content">
          <h1>EMBAJADORAS</h1>
        </div>
        <img src="/IMG1-EMBAJADORAS.jpeg" alt="Embajadoras" className="sx-historia-img sx-embajadoras-img" />
        <div className="sx-historia-content">
          <p>Nuestras embajadoras y el papel que juegan en comunidad.</p>
          <a onClick={() => navigate('/embajadoras')} className="sx-descubrir" style={{ cursor: 'pointer' }}>Descubrir</a>
        </div>
      </section>

      {/* ══ REINADOS ══ */}
      <section id="reinados" className="sx-seccion-reinados">
        <div className="sx-reinados-overlay" />
        <div className="sx-historia-content">
          <h1>REINADOS</h1>
          <p>Explora nuestra primera experiencia.</p>
        </div>
      </section>

      {/* ══ EDICIONES ══ */}
      <section id="ediciones" className="sx-seccion-beige">
        <div className="sx-beige-content">
          <h1 style={{fontVariantNumeric: 'lining-nums'}}>1ER EDICIÓN</h1>
          <img src="/IMG2-1EREDICION.jpeg" alt="1er Edición" className="sx-edicion-img" />
          <p>Vive el prelanzamiento <strong>RVMX</strong> y disfruta las sorpresas que tenemos para ti.</p>
        </div>
      </section>

      {/* ══ SPONSORS ══ */}
      <section id="sponsors" className="sx-seccion-beige">
        <div className="sx-beige-content">
          <h1>SPONSORS</h1>
          <img src="/IMG1-SPONSORS.jpeg" alt="Sponsors" className="sx-edicion-img" />
          <p>Nuestra marca fundadora y las próximas que compartirán la visión del certamen en todo el país, muy pronto.</p>
         <a onClick={() => navigate('/sponsors')} className="sx-descubrir" style={{ cursor: 'pointer' }}>Contacto</a>
        </div>
      </section>

      {/* ══ ALIANZAS ══ */}
      <section id="alianzas" className="sx-seccion-beige">
        <div className="sx-beige-content">
          <h1>ALIANZAS</h1>
          <img src="/IMG1-ALIANZAS.jpeg" alt="Alianzas" className="sx-edicion-img" />
          <p>Juntos construimos algo más grande, conoce la alianza comercial con <strong>Festival VV</strong>, <strong>The AG Gallery</strong> y las empresas que acompañan nuestra visión.</p>
        </div>
      </section>

      {/* MODAL */}
      {itemActivo && (
        <div className="sx-modal-overlay" onClick={() => setItemActivo(null)}>
          <div className="sx-modal" onClick={(e) => e.stopPropagation()}>
            <button className="sx-modal-close" onClick={() => setItemActivo(null)}>✕</button>
            <img src={itemActivo.img} alt={itemActivo.titulo} className="sx-modal-img" />
            <div className="sx-modal-info">
              <span className="sx-card-cat">{itemActivo.categoria}</span>
              <h2>{itemActivo.titulo}</h2>
            </div>
          </div>
        </div>
      )}

      {/* ══ FOOTER ══ */}
      <footer className="sx-footer">
        <p>Reina del Vino — © Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default AGIndustries;